<template>
    <div>
        <div class="card shadow">
            <div class="card-header bg-transparent">
                <div>
                    <h3 class="mb-0">
                        {{ $tc('message.conclusions', 1) }}
                    </h3>
                </div>
            </div>

            <div class="card-body">
                <div class="card">
                    <div class="card-body p-1em">
                        <h3 class="card-title text-center mb-0">
                            {{ mConclusion.reference }}
                        </h3>
                    </div>
                    <b-container>
                        <div class="list-group list-group-flush">
                            <b-row>
                                <div class="col-sm-12">
                                    <div class="list-group-item">
                                        {{ $t('message.reference') }}:

                                        <span class="font-weight-bold">
                                {{ mConclusion.reference }}
                            </span>
                                    </div>
                                </div>
                                <div class="col-sm-12">
                                    <div class="list-group-item">
                                        {{ $t('message.description') }}:

                                        <span class="font-weight-bold" v-html="mConclusion.description">
                                        </span>
                                    </div>
                                </div>
                            </b-row>
                            <b-row class="justify-content-sm-center" v-if="can">
                                <div class="card-footer text-right">
                                    <b-button variant="primary" @click="updateConclusion">
                                        {{ $t('message.edit') }}
                                    </b-button>

                                    <b-button v-b-modal.delete-modal variant="danger">
                                        {{ $t('message.delete') }}
                                    </b-button>
                                </div>
                            </b-row>
                        </div>
                    </b-container>

                    <b-modal
                            id="delete-modal"
                            size="sm"
                            header-bg-variant="danger"
                            header-text-variant="light"
                            :title="$t('message.delete') + ' ' + $tc('message.conclusions', 1)"
                            hide-footer
                    >
                        <div class="d-block text-center">
                            <h3>{{ $t('message.delete') }} {{ mConclusion.reference }}?</h3>
                        </div>

                        <div class="d-block float-right" v-if="can">
                            <b-button variant="danger" @click="deleteConclusion">
                                {{ $t('message.delete') }}
                            </b-button>

                            <b-button variant="secondary" @click="$bvModal.hide('delete-modal')">
                                {{ $t('message.cancel') }}
                            </b-button>
                        </div>
                    </b-modal>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';

    export default {
        name: "Conclusion",

        computed: {
            ...mapGetters(["conclusion",
                'hasAdminRole',
                'hasMedecinControleRole',
                "hasSouscripteurRole ",
                "hasPatientRole",
                'hasPraticienRole']),

            can:function(){
              return this.hasAdminRole || this.mConclusion.isAuthor;
            },

            mConclusion: function() {
                return this.conclusion;
            }
        },

        data() {
            return {
                conclusion_id: this.$route.params.conclusion
            }
        },

        methods: {
            getConclusion() {
                let args = {
                    conclusion: this.conclusion_id
                };

                this.$store.dispatch("getConclusion", { args });
            },

            updateConclusion() {
                this.$router.push({ name: 'edit-conclusion', params: { conclusion: this.conclusion_id } });
            },

            deleteConclusion() {
                let self = this;
                let args = {
                    conclusion: this.conclusion_id
                };

                let successMessage = this.$i18n.t('message.conclusionDeleted');
                let errorMessages = {
                    generic: this.$i18n.t('message.genericError'),
                    error: this.$i18n.t('message.error')
                };

                this.$store.dispatch('deleteConclusion', { args, index: self.conclusion_id, successMessage, errorMessages }).then(() => {
                    self.$bvModal.hide('delete-modal');
                    this.$router.back();

                });
            }
        },

        mounted() {
            this.getConclusion();
        }
    }
</script>

<style scoped>

</style>